module.exports = __webpack_public_path__ + "img/belgium-digestive-diseases-female.2aabe680.png";